import React, { useCallback, useRef } from 'react'
import Button from 'Components/button'
import classNames from 'classnames'

interface IVideoUploader {
  onChange: (file: File | undefined) => void
  videoFile: File | undefined
  onConfirmUpload: () => void
  saved: boolean
  loading: boolean
  errMsg: string
}

export default function VideoUploader(props: IVideoUploader) {
  const { onChange, videoFile, onConfirmUpload, saved, errMsg, loading } = props
  const inputRef = useRef<HTMLInputElement>(null)

  const handleChooseVideo = useCallback(
    (eve: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = eve.target
      onChange(files?.[0])
    },
    [onChange]
  )
  const handleReUpload = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }, [])

  return (
    <div className="video-uploader">
      <div className="upload-area">
        {!videoFile ? (
          <span className="placeholder">视频文件</span>
        ) : (
          <p className="file-name">{videoFile?.name}</p>
        )}
        <input
          type="file"
          className="video-input"
          accept="video/quicktime,video/mp4"
          onChange={handleChooseVideo}
          ref={inputRef}
        />
      </div>
      <p className="error-message">{errMsg}</p>
      <div className="button-group">
        {saved || errMsg !== '' ? (
          <Button
            type="new_primary"
            className="re-upload"
            onClick={handleReUpload}
            loading={loading}
          >
            重新上传
          </Button>
        ) : (
          <Button
            type="new_primary"
            className={classNames(
              'confirm-upload',
              videoFile?.name === '' && 'disabled'
            )}
            onClick={onConfirmUpload}
            loading={loading}
          >
            确认上传
          </Button>
        )}
      </div>
      <style jsx>
        {`
          .video-uploader {
            padding-top: 16px;
          }
          .upload-area {
            padding: 8px 16px;
            border-radius: 2px;
            border: 1px solid #c9cbd6;
            position: relative;
            box-sizing: border-box;
          }
          .placeholder {
            font-size: 14px;
            color: #979aa8;
          }
          .file-name {
            font-size: 14px;
            color: #1f2129;
            max-height: 314px;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .video-input {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            cursor: pointer;
          }
          .error-message {
            color: #e62021;
            font-size: 12px;
            line-height: 1.4;
            transform: scale(0.833);
            transform-origin: left center;
            position: absolute;
          }

          .button-group {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 16px;
          }
          :global(.video-uploader .re-upload, .video-uploader .confirm-upload) {
            width: 88px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: normal;
            color: #1f2129;
          }
        `}
      </style>
    </div>
  )
}
